const enum GLOBALSTORAGE {
	SELLIGENT = 'selligent',
	CONSENT = 'consent',
	POPUP_NOTIFICATION = 'popup-notification',
}

export default GLOBALSTORAGE
